var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculatorimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.24,
    height: 34.711,
    viewBox: "0 0 31.24 34.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#582bb8;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.9,34.711l2.6-2.6,2.6,2.6,2.6-2.6,2.6,2.6,2.6-2.6,2.6,2.6,2.6-2.6,2.6,2.6,2.6-2.6,2.6,2.6,2.6-2.6,2.6,2.6V2.042A2.043,2.043,0,0,0,34.1,0H6.94A2.038,2.038,0,0,0,4.9,2.042Zm26.033-15.62H10.109V15.62H30.935Zm0,6.942H10.109V22.562H30.935ZM15.111,9.188h3.063V7.147H15.111V4.084H13.069V7.147H10.007V9.188h3.062v3.063h2.042Zm7.249,2.553V8.27h8.576v3.471Z",
    transform: "translate(-4.902 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorimg);
export default __webpack_public_path__ + "static/media/calculatorimg.703bd5c8eb4fa9a53913f59f7ac47ab0.svg";
export { ForwardRef as ReactComponent };